import React, { Component } from 'react';
import ReactEcharts from 'echarts-for-react';

class CreditorsDay2 extends Component {
    // Helper function to calculate the trend line using linear regression
    calculateTrendLine = (data) => {
        const n = data.length;
        const x = Array.from({ length: n }, (_, i) => i + 1); // Create an array of x values [1, 2, 3, ..., n]
        const y = data;
        
        // Calculate averages
        const xAvg = x.reduce((sum, val) => sum + val, 0) / n;
        const yAvg = y.reduce((sum, val) => sum + val, 0) / n;

        // Calculate slope (m) and intercept (b) for the line y = mx + b
        let numerator = 0;
        let denominator = 0;
        for (let i = 0; i < n; i++) {
            numerator += (x[i] - xAvg) * (y[i] - yAvg);
            denominator += Math.pow(x[i] - xAvg, 2);
        }

        const m = numerator / denominator; // slope
        const b = yAvg - m * xAvg; // intercept

        // Calculate trend line values (y values for each x)
        const trendLine = x.map(xValue => m * xValue + b);
        return trendLine;
    };

    getOption = () => {
        const dates = [
            "Nov-19", "Dec-19", "Jan-20", "Feb-20", "Mar-20", "Apr-20", "May-20", "Jun-20", "Jul-20", "Aug-20", "Sep-20", "Oct-20", 
            "Nov-20", "Dec-20", "Jan-21", "Feb-21", "Mar-21", "Apr-21", "May-21", "Jun-21", "Jul-21", "Aug-21", "Sep-21", "Oct-21", 
            "Nov-21", "Dec-21", "Jan-22", "Feb-22", "Mar-22", "Apr-22", "May-22", "Jun-22", "Jul-22", "Aug-22", "Sep-22", "Oct-22", 
            "Nov-22", "Dec-22", "Jan-23", "Feb-23", "Mar-23", "Apr-23", "May-23", "Jun-23", "Jul-23", "Aug-23", "Sep-23", "Oct-23", 
            "Nov-23", "Dec-23", "Jan-24", "Feb-24", "Mar-24", "Apr-24", "May-24", "Jun-24", "Jul-24", "Aug-24", "Sep-24", "Oct-24"
        ];

        const creditorsDaysOutstanding = [
            6.0, 1.1, 10.6, 7.6, 7.3, 13.8, 13.7, 4.9, 15.3, 6.4, 9.6, 7.2, 9.5, 9.5, 6.9, 25.7, 20.1, 18.0, 16.4, 14.0, 8.9, 
            12.9, 8.8, 8.1, 9.3, 2.3, 6.1, 11.6, 7.7, 8.9, 9.8, 5.6, 7.7, 7.8, 9.7, 7.3, 5.0, 5.0, 8.4, 8.9, 9.7, 9.7, 13.1, 
            10.9, 18.1, 13.9, 22.3, 16.5, 13.1, 10.5, 9.6, 7.2, 13.5, 15.1, 11.1, 9.0, 9.3, 6.3, 3.8, 6.6
        ];

        const trendLine = this.calculateTrendLine(creditorsDaysOutstanding); // Calculate the trend line
        
        return {
            tooltip: { trigger: 'axis' },
            grid: { left: '50px', right: '50px', top: '30px', bottom: '60px' },
            xAxis: {
                type: 'category',
                data: dates,
                axisLabel: { rotate: 45, color: "#74788d" },
                axisLine: { lineStyle: { color: "#74788d" } }
            },
            yAxis: {
                type: 'value',
                axisLine: { lineStyle: { color: "#74788d" } }
            },
            series: [
                {
                    name: 'Creditors Days Outstanding',
                    data: creditorsDaysOutstanding,
                    type: 'line',
                    smooth: true,
                    lineStyle: { color: '#3c4ccf' },
                    itemStyle: { color: '#3c4ccf' }
                },
                {
                    name: 'Trend Line',
                    data: trendLine,
                    type: 'line',
                    smooth: true,
                    lineStyle: { color: '#ff7f0e', type: 'dashed' }, // Orange dashed trend line
                    itemStyle: { color: '#ff7f0e' }
                }
            ],
            color: ['#3c4ccf', '#ff7f0e'] // Blue for actual data, orange for trend line
        };
    };

    render() {
        return (
            <React.Fragment>
                <ReactEcharts style={{ height: "350px", width: "100%" }} option={this.getOption()} />
            </React.Fragment>
        );
    }
}

export default CreditorsDay2;
